/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/**
 * Centralized refresh intervals for Docker container data fetching
 * All intervals are in milliseconds
 */
export const DOCKER_REFRESH_INTERVALS = {
  // Host list refresh
  HOSTS_LIST: 30000, // 30 seconds

  // Container list + latest stats
  CONTAINERS: 10000, // 10 seconds

  // Resource history (chart data)
  STATS: 15000, // 15 seconds

  // Log tail
  LOGS: 5000, // 5 seconds
} as const;

export type DockerRefreshInterval =
  (typeof DOCKER_REFRESH_INTERVALS)[keyof typeof DOCKER_REFRESH_INTERVALS];
